import React, {Component} from 'react';

class Timer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            time: this.props.second,
        }
    }

    componentDidMount() {
        this.setState({
            interval: setInterval(() => {
                if (this.state.time > 0)
                    this.setState({time: this.state.time - 1})
                else {
                    clearInterval(this.state.interval)
                    if (this.props.onEnd)
                        this.props.onEnd()
                }
            }, 1000)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.second !== this.props.second) {
            this.setState({
                time: this.props.second,
            })
            setTimeout(() => {
                clearInterval(this.state.interval)
                this.setState({
                    interval: setInterval(() => {
                        if (this.state.time > 0)
                            this.setState({time: this.state.time - 1})
                        else {
                            clearInterval(this.state.interval)
                            if (this.props.onEnd)
                                this.props.onEnd()
                        }
                    }, 1000)
                })
            }, 1200)
        }
    }

    componentWillUnmount() {
        if (this.state.interval)
            clearInterval(this.state.interval)
    }

    getTime = () => {
        let min = Math.floor(this.state.time / 60)
        let sec = Math.floor(this.state.time % 60)

        return (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec)
    }

    render() {
        return (this.state.time === 0 ? (this.props.children) :
                (
                    <span>{(this.props.extraText ? this.props.extraText + ' ' : '') + this.getTime()}</span>)
        );
    }
}

export default Timer
